import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Null when the env vars aren't configured (e.g. a fresh checkout without a
// .env) — every caller treats that as "cloud accounts unavailable" and
// falls back to guest-only play, same offline-tolerant contract as
// LeaderboardClient's unreachable-server path.
export const supabase = supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;
